export default __webpack_public_path__ + "static/media/banner.ee91513b.png";